import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
const _excluded = ["givenName", "familyName"];
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/values";
import _Map from "@babel/runtime-corejs3/core-js/map";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapState, mapGetters } from "vuex";
import { LOAD_BOARD_COLLABORATORS, CHANGE_PROFILE_OWNER } from "@Broker/@Modules/clients/board/store/board-actions";
import { COLLABORATORS } from "@Broker/@Modules/clients/board/store/board-getters";
import ProfileAvatar from "@Shared/components/general/profile-avatar";
import { showToast } from "@Shared/utils/constants";
import Err from "@Broker/@Routes/error";
import { isEmpty, values } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "CollaboratorsDropdown",
  components: {
    ProfileAvatar
  },
  props: {
    clientProfileId: {
      type: [String, Number],
      required: true
    },
    boardId: {
      type: [String, Number],
      required: true
    },
    profile: {
      type: Object,
      required: true
    }
  },
  computed: _objectSpread(_objectSpread({}, mapGetters("BoardStore", [COLLABORATORS])), {}, {
    boardCollaborators() {
      return this.COLLABORATORS(this.boardId);
    }
  }, mapState("BoardStore", {
    collaborators(state) {
      var _context, _context2;
      const clientBoard = state.boards.byId[this.boardId];
      if (!clientBoard) return [];
      const boardCollaborators = values(this.boardCollaborators);
      const allCollaborators = _filterInstanceProperty(_context = [...boardCollaborators, clientBoard.ownerDetails]).call(_context, ({
        username
      }) => {
        var _this$profile, _this$profile$owner;
        return username !== ((_this$profile = this.profile) == null ? void 0 : (_this$profile$owner = _this$profile.owner) == null ? void 0 : _this$profile$owner.username);
      });
      return [..._valuesInstanceProperty(_context2 = new _Map(_mapInstanceProperty(allCollaborators).call(allCollaborators, item => [item.username, item]))).call(_context2)];
    }
  })),
  watch: {
    boardId() {
      this.LOAD_BOARD_COLLABORATORS(this);
    }
  },
  mounted() {
    if (isEmpty(this.boardCollaborators)) {
      this.LOAD_BOARD_COLLABORATORS(this);
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions("BoardStore", [LOAD_BOARD_COLLABORATORS, CHANGE_PROFILE_OWNER])), {}, {
    async changeOwner(_ref) {
      let {
          givenName,
          familyName
        } = _ref,
        data = _objectWithoutProperties(_ref, _excluded);
      try {
        this.$emit("disable-dropdown");
        await this.CHANGE_PROFILE_OWNER({
          id: this.clientProfileId,
          owner: _objectSpread({
            givenName,
            familyName
          }, data),
          clientUsername: this.profile.linkedAccountUsername
        });
        showToast("success", "clientTransferred");
        this.$emit("change-ownership");
      } catch (error) {
        Err.handle(error);
      } finally {
        this.$emit("enable-dropdown");
      }
    }
  })
});